import React from 'react';
import { AlertTriangle, Package, MapPin, Mail } from 'lucide-react';
import { 
  getStocksEnAlerte,
  getProduitById,
  getCentreById,
  getCategorieById 
} from '../../data/mockData';

function AlertesStock({ user }) {
  const alertes = getStocksEnAlerte();

  const handleSendEmail = (stock) => {
    const produit = getProduitById(stock.produitId);
    const centre = getCentreById(stock.centreId);
    
    console.log('Envoi email alerte:', {
      produit: produit?.nom,
      centre: centre?.nom,
      quantite: stock.quantite,
      seuil: produit?.seuilAlerte,
    });

    alert(`Email envoyé à l'administrateur pour le produit "${produit?.nom}" du centre "${centre?.nom}"`);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Alertes stock</h1>
          <p className="text-muted">Produits nécessitant une commande</p>
        </div>
      </div>

      {alertes.length === 0 ? (
        <div className="empty-state">
          <Package size={48} className="icon-success" />
          <p>Aucune alerte stock actuellement</p>
          <p className="text-muted">Tous les produits sont au-dessus du seuil d'alerte</p>
        </div>
      ) : (
        <>
          <div className="info-box info-warning">
            <AlertTriangle size={20} />
            <p>
              <strong>{alertes.length} produit(s)</strong> sont en dessous du seuil d'alerte 
              et nécessitent une commande.
            </p>
          </div>

          <div className="alertes-grid">
            {alertes.map(stock => {
              const produit = getProduitById(stock.produitId);
              const centre = getCentreById(stock.centreId);
              const categorie = getCategorieById(produit?.categorieId);
              
              return (
                <div key={stock.id} className="alerte-card">
                  <div className="alerte-header">
                    <AlertTriangle size={24} className="icon-danger" />
                    <span className="badge badge-danger">Alerte</span>
                  </div>

                  <div className="alerte-body">
                    <h3>{produit?.nom}</h3>
                    <div className="alerte-info">
                      <div className="info-row">
                        <Package size={16} className="icon-muted" />
                        <span className="badge badge-secondary">{categorie?.nom}</span>
                      </div>

                      <div className="info-row">
                        <MapPin size={16} className="icon-muted" />
                        <span>{centre?.nom}</span>
                      </div>
                    </div>

                    <div className="stock-levels">
                      <div className="stock-level">
                        <p className="text-sm text-muted">Stock actuel</p>
                        <p className="stock-value stock-danger">
                          <strong>{stock.quantite}</strong> {produit?.unite}
                        </p>
                      </div>

                      <div className="stock-separator">→</div>

                      <div className="stock-level">
                        <p className="text-sm text-muted">Seuil d'alerte</p>
                        <p className="stock-value">
                          <strong>{produit?.seuilAlerte}</strong> {produit?.unite}
                        </p>
                      </div>
                    </div>

                    {produit?.description && (
                      <div className="alerte-description">
                        <p className="text-sm text-muted">{produit.description}</p>
                      </div>
                    )}
                  </div>

                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

export default AlertesStock;

